module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "people d-flex flex-column"
  }, [_c('div', [_c('div', {
    staticClass: "navigator"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("My Agents")]), _vm._v(" "), _c('invite')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1 overflow-auto"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": ""
    }
  }, [_c('agents')], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0708f589"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/People.vue
// module id = 2536
// module chunks = 0